export default {
  // 菜单相关路由
  menus: [
    { key: '/home/roomtype', title: '房态管理', icon: 'down', component: 'RoomType', action: 'roomTypePage' },
    { key: '/home/orderlist', title: '订单管理', icon: 'down', component: 'OrderList', action: 'orderPage'
      // subs: [
      //   { key: '/home/frontorder', title: '前台下单', component: 'FrontOrder'}
      // ]
    },
    { key: '/home/clean', title: '清洁服务', icon: 'down', component: 'Clean', action: 'cleanServicePage' },
    { key: '/home/report', title: '报表中心', icon: 'down', component: 'Report', action: 'reportCenterPage' },
    { key: '/home/roomprice', title: '收益管理', icon: 'down', component: 'RoomPrice', action: 'earningsManagerPage' },
    { key: '/home/basesetting', title: '基础管理', icon: 'down', component: 'BaseSetting', action: 'baseSettingPage' },
  ],
  // 非菜单相关路由
  others: [
    { key: '/home/longtype',component: 'LongRoomType' },
    { key: '/home/createorder/:type', component: 'CreateOrder' },
    // { key: '/home/rowroom/:reservationNo', component: 'RowRoom' },
    // { key: '/home/nonpaymentdetail/:orderNo', component: 'NonPaymentDetail' },
    { key: '/home/nonpaymentdetail', component: 'NonPaymentDetail' },
    { key: '/home/orderdetail', component: 'NormalDetail' },
    { key: '/home/password', component: 'Password' },
    { key: '/home/profitdetail', component: 'PrifitDetail' },
    { key: '/home/settlementdetail', component: 'SettlementDetail' }
  ]
}


// WEBPACK FOOTER //
// ./src/routes/config.js